import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_stock bg_stock text_white">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/stock/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={406}
                height={153}
              />
            </div>
            <p>
              Stock n Ship is a platform designed for businesses to manage their
              inventory, orders, product supplies, and customer refunds in a
              better-redefined manner through portals.
            </p>
            <p>
              Reducing barriers and enabling businesses to have autonomy over
              their stock is what Stock n Ship aims to do.
            </p>
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/stock/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1092}
                height={1023}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
